<template>
  <ResponseContainer :loading="!party">
    <div v-if="auth">
      <h2>Is this {{ this.single ? "you" : "your party" }}?</h2>
      <div class="border rounded p-4">
        <p class="font-bold">{{ group.name }}</p>
        <p class="mb-4 text-theme-navy/40">{{ party }}</p>
        <button @click="goToNext()">This is {{ this.single ? "me" : "us" }} →</button>
        <div class="flex justify-center w-full">
          <button @click="goToAuth()" class="block secondary-button underline">Not {{ this.single ? "me" : "us" }}, go back!</button>
        </div>
      </div>
    </div>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'

export default {
  name: 'ResponseNamePage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      name: undefined,
      auth: false,
      group: undefined,
      party: undefined,
      single: undefined,
    }
  },
  beforeMount() {
    this.loadParty()
  },
  methods: {
    async loadParty() {
      this.group = await Group.current()
      if (this.group) this.auth = true
      const members = await this.group.members
      this.single = members.length === 1
      this.party = members.map(m => m.name).join(', ')
    },
    goToAuth() {
      // TODO: Log out the current group.
      this.$router.push('/login')
    },
    goToNext() {
      if (this.group.rsvped) {
        this.$router.push('/rsvp/responded')
      } else {
        this.$router.push('/rsvp/events')
      }
    },   
  },
}
</script>